import cookies from 'js-cookie';
import get from 'lodash/get';

const cookieExpirationDays = 20;
const cookieName = 'acl_visited_tours';

export interface LastSeenTour {
    id: number;
    visits: number;
    last: number;
}

export const getVisitedToursData = (): LastSeenTour[] => {
    const cookie = cookies.get(cookieName);
    try {
        const parsed = cookie ? JSON.parse(atob(cookie)) : [];
        if (Array.isArray(parsed)) {
            return parsed;
        }
        cookies.remove(cookieName);
    } catch (e) {
        cookies.remove(cookieName);
    }
    return [];
};

/**
 * Track tour page visits by writing them to cookies.
 *
 * @param {number} tourId
 */
export const trackTour = (tourId: number): void => {
    const visitedToursData = getVisitedToursData().filter((tour) => tour.id !== tourId);
    const tourData: LastSeenTour = {
        id: tourId,
        visits: get(visitedToursData, `${tourId}.visits`, 0) + 1,
        last: Date.now(),
    };
    visitedToursData.push(tourData);
    cookies.set(
        cookieName,
        btoa(JSON.stringify(visitedToursData.sort((a, b) => b.last - a.last).slice(0, 8))),
        { expires: cookieExpirationDays, path: '/' },
    );
};



// WEBPACK FOOTER //
// ./src/helpers/lastSeenTours.ts